// extracted by mini-css-extract-plugin
module.exports = {"dot":"ReminderDot_dot__1m12l"};